import React from "react"
import FieldCrmContactType_Value from "../value/value"
import { FieldEditableValueNotEmptyProps } from "../../../../../proto/components/editable/value-not-empty";

// the inline editable keeps the option itself (see FieldDropdown_InlineEditable)
export default function FieldCrmContactType_InlineValueNotEmpty(props:FieldEditableValueNotEmptyProps) {

    return (
        <FieldCrmContactType_Value
            option          = {props.option}
            size            = {props.size}
            className       = {props.className}
            labelClassName  = {props.configOptions?.labelClassName}
            onClick         = {props.onClick}
        >
            {props.children}
        </FieldCrmContactType_Value>
    )
}
